module.exports = __webpack_public_path__ + "20260128d142218t/img/learning-cuate-icon2.d4c465b4.png";